export const SIZES = {
    tiny: 'tiny',
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=Button.constants.js.map